<template>
    <span class="yushu-upload-file">
        <el-upload ref="upload" class="upload-demo" style="display:inline-block;line-height:0px;" :headers="uploadHeaders" :accept="accept" :auto-upload="autoUpload" :action="action" :limit="1" :show-file-list="showFile" :file-list="fileList" :before-upload="onBeforeUploadFile" :on-success="onUploadSuccess" :on-change="onChangeFile" :on-remove="onRemoveFile" :on-error="onUploadError">
            <el-button v-if="showStyle == 'button' && (fileList.length == 0 || !showFile)" :type="showType" :size="size" :plain="plain" :effect="effect">
                <span class="el-icon-upload2">{{text}}</span>
            </el-button>
            <div v-else-if="showStyle == 'dropdown'">
                <i class="el-icon-upload2"></i>{{text}}
            </div>
            <template v-else-if="showStyle == 'button-text'">
                <el-button v-if="(fileList.length == 0 || !showFile)" type="text" :size="size">
                    <span class="el-icon-upload2">{{text}}</span>
                </el-button>
            </template>
        </el-upload>
    </span>
</template>
<script>
import { getToken } from '@/web-framework/api/token';
export default {
    props: {
        autoUpload: {
            type: Boolean,
            default: true
        },
        action: {
            type: String,
            default : "/api/storage/resources/upload"
        },
        onChange: {
            type: Function,
            default: () => {
                return;
            }
        },
        onRemove: {
            type: Function,
            default: () => {
                return;
            }
        },
        beforeUpload: {
            type: Function,
            default: () => {
                return true;
            }
        },
        afterUpload: {
            type: Function,
            default: () => {
            }
        },
        text: {
            type: String,
            default: "上传文件"
        },
        showFile: {
            type: Boolean,
            default: true
        },
        showMessage: {
            type: Boolean,
            default: true
        },
        showType: {
            type: String,
            default: () => {
                return "primary"
            }
        },
        showStyle: {
            type: String,
            default: () => {
                return 'button'
            }
        },
        initFileList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        effect: {
            type: String,
            default: ''
        },
        plain: {
            type: Boolean,
            default: true
        },
        accept: {
            type: String,
            default: '*'
        },
        rowKey: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'mini'
        }
    },
    data() {
        return {
            loading: false,
            fileList: [],
            uploadHeaders: {
                authorization: getToken(),
                'model': this.$route.name
            }
        }
    },
    mounted() {
        if (this.initFileList && this.initFileList.length > 0) {
            this.fileList = this.initFileList;
        }
    },
    methods: {
        onBeforeUploadFile() {
            this.loading = true;
            return this.beforeUpload();
        },
        //文件状态改变
        onChangeFile(file, fileList) {
            this.fileList = fileList;
            if (this.onChange) {
                this.onChange(file, this.fileList);
            }
        },
        onRemoveFile(file, fileList) {
            this.fileList = fileList;
            this.$refs.upload.clearFiles();
            if (this.onRemove) {
                this.onRemove(file, this.fileList);
            }
        },
        onUploadError(response, file, fileList) {
            this.loading = false;
            this.$refs.upload.clearFiles();
        },
        submit() {
            if (this.$refs.upload) {
                this.$refs.upload.submit();
            }
        },
        onUploadSuccess(fileInfo) {
            this.loading = false;
            if (!fileInfo.success) {
                if (fileInfo.message) {
                    this.$message.error(fileInfo.message);
                } else {
                    this.$message.error('上传失败');
                }
                return;
            }

            if (this.showMessage)
                this.$message.success("文件上传成功");

            if (!this.showFile)
                this.$refs.upload.clearFiles();

            if (this.afterUpload) {
                this.afterUpload(fileInfo.data, this.rowKey);
            }
        },
    }
}
</script>
<style lang="less" scoped>
.yushu-upload-file {
    display:flex;
    /deep/.el-upload-list__item.is-success {
        margin-top: 4px;
    }
    .el-button {
        padding-bottom: 5.5px;
        padding-top: 8.5px;
    }
}
.el-button-group {
    .yushu-upload-file {
        .el-button:not(:first-child):not(:last-child) {
            border-radius: 0;
        }
        .el-button:not(:first-child):not(:last-child) {
            border-left-color: rgba(255, 255, 255, 0.5);
            border-right-color: rgba(255, 255, 255, 0.5);
        }
        .el-button:not(:last-child) {
            margin-right: -1px;
        }
        .el-button + .el-button {
            margin-left: 0;
        }
    }
}
</style>